import { css } from 'lit';

export default css`
  /* Border Radius */
  --radius-sm: 0.3125rem;           /* Small radius */
  --radius-md: 0.5rem;              /* Medium radius */
  --radius-lg: 0.625rem;            /* Large radius */
  --radius-full: 50%;               /* Full circle */
  --radius-dynamic: clamp(var(--radius-sm), 1vw, var(--radius-lg)); /* Responsive radius */

  /* Borders */
  --xs-line: 1px;                   /* Extra small border */
  --sm-line: 2px;                   /* Small border */
  --md-line: 3px;                   /* Medium border */
  --lg-line: 5px;                   /* Large border */
  --border-color: var(--color-gray-4); /* Default border color */
  --border-color-focus: var(--color-primary); /* Focus border color */
  --border-style: solid;            /* Default border style */
`;
